module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_DVD_Player.662b5193.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_DVD_Player.svg
// module id = 1604
// module chunks = 0